"use client";

import * as React from "react";
import { Separator } from "@/components/ui/separator";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const galleryItems = [{
  id: "item-1",
  title: "Birria Estilo Jalisco",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/3-2.png"
}, {
  id: "item-2",
  title: "Carnitas Michoacanas",
  image: "https://banquetesorzuna.com/wp-content/uploads/2026/03/4-2.jpg?v=jpy3n6oixr"
}, {
  id: "item-3",
  title: "Mole Poblano Especial",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/1-1.png"
}, {
  id: "item-4",
  title: "Salsas de la Casa",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/25.png"
}, {
  id: "item-5",
  title: "Eventos y Banquetes",
  image: "https://banquetesorzuna.com/wp-content/uploads/2026/03/4.jpg?v=g3cplwegw3b"
}, {
  id: "item-6",
  title: "Herencia Familiar",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/2.png"
}, {
  id: "item-7",
  title: "Tacos al Pastor",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/8.png"
}, {
  id: "item-8",
  title: "Pozole Rojo Tradicional",
  image: "https://banquetesorzuna.com/wp-content/uploads/2026/04/4.jpg?v=letnlk16dxe"
}, {
  id: "item-9",
  title: "Chiles en Nogada",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/25.png"
}, {
  id: "item-10",
  title: "Enchiladas Verdes",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/15.png"
}, {
  id: "item-11",
  title: "Tamales Oaxaqueños",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/19.png"
}, {
  id: "item-12",
  title: "Esquites y Elotes",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/21.png"
}, {
  id: "item-13",
  title: "Aguas Frescas",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/18.png"
}, {
  id: "item-14",
  title: "Postres Mexicanos",
  image: "https://banquetesorzuna.com/wp-content/uploads/2026/04/1.jpg?v=4r751xwtxpc"
}, {
  id: "item-15",
  title: "Montaje de Eventos",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/2.png"
}, {
  id: "item-16",
  title: "Servicio Profesional",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/24.png"
}];
export default function Gallery() {
  return <section data-section-id="146432" id="gallery" className="py-32 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        
        <div className="flex flex-col items-center mb-16 md:mb-24">
          <h2 className="text-4xl md:text-5xl lg:text-7xl font-serif text-center tracking-tight mb-6 text-primary">Galeria</h2>
          <Separator className="w-32 bg-chart-3/60 h-[2px]" />
        </div>

        
        <div className="w-full rounded-xl pb-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          <div className="col-span-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
            {galleryItems.map((item, i) => <div key={item.id} data-index={i} className="flex flex-col group cursor-pointer">
                
                <div className="overflow-hidden rounded-lg bg-accent/20 mb-6 shadow-md transition-shadow duration-500 group-hover:shadow-xl">
                  <AspectRatio ratio={3 / 4}>
                    <img src={item.image} alt={item.title} className="object-cover w-full h-full transition-transform duration-700 ease-out group-hover:scale-105" loading="lazy" />
                  </AspectRatio>
                </div>

                
                
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}